export const cnvTimestampToDateStr = (timestamp) => {
    let options = {}
    options.year = 'numeric'
    options.month = 'short'
    options.day = 'numeric'
    options.timeZone = 'UTC'
    options.timeZoneName = 'short'
    let date = new Date(timestamp)
    return date.toLocaleString('en-US', options)
}

export const cnvTimestampToDHMS = (ms) => {
    const days = Math.floor(ms / (24*60*60*1000));
    const daysms = ms % (24*60*60*1000);
    const hours = Math.floor(daysms / (60*60*1000));
    const hoursms = ms % (60*60*1000);
    const minutes = Math.floor(hoursms / (60*1000));
    const minutesms = ms % (60*1000);
    const seconds = Math.floor(minutesms / 1000);
    return {
        days: String(days).padStart(2, "0"),
        hours: String(hours).padStart(2, "0"),
        minutes: String(minutes).padStart(2, "0"),
        seconds: String(seconds).padStart(2, "0")
    }
}